module.exports = __webpack_public_path__ + "img/icon_1.7dc472a4.svg";